// extracted by mini-css-extract-plugin
export default {"dropdownInfoWrapper":"styles_dropdownInfoWrapper__YetPw","dropdownBox":"styles_dropdownBox__I4KPC","open":"styles_open__uajXP"};